var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHubspot = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 29,
    viewBox: "0 0 100 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_158_53106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.0849 0.0977783H0.976562V28.0658H99.0849V0.0977783Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_158_53106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5906 4.73865V12.6302H4.39256V4.73865H0.976562V23.568H4.39256V15.9422H11.5906V23.568H15.0269V4.73865H11.5906Z",
    fill: "#010202"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_158_53106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0849 0.0977783H0.976562V28.0658H99.0849V0.0977783Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_158_53106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9665 17.4756C25.9665 18.232 25.6615 18.9476 25.1329 19.4791C24.6042 20.0107 23.8722 20.3174 23.1402 20.3174C22.3879 20.3174 21.6762 20.0107 21.1475 19.4791C20.6189 18.9476 20.3139 18.232 20.3139 17.4756V9.42047H17.0605V17.4756C17.0605 19.0907 17.6909 20.6445 18.8295 21.7894C19.9682 22.9342 21.5135 23.568 23.1199 23.568C24.7262 23.568 26.2715 22.9342 27.4102 21.7894C28.5489 20.6445 29.1792 19.0907 29.1792 17.4756V9.42047H25.9462V17.4756H25.9665Z",
    fill: "#010202"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_158_53106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 29
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0849 0.0977783H0.976562V28.0658H99.0849V0.0977783Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_158_53106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 10.2382C49.9999 8.58221 51.0979 8.07109 52.2772 8.07109C53.2329 8.07109 54.5139 8.80709 55.3272 9.70665L57.4622 7.19198C56.4049 5.74043 54.2495 4.75909 52.4805 4.75909C48.9629 4.75909 46.4212 6.82398 46.4212 10.2586C46.4212 16.6373 54.1682 14.6133 54.1682 18.1706C54.1682 19.2746 53.1109 20.2355 51.8909 20.2355C49.9795 20.2355 49.3492 19.2951 48.4749 18.2933L46.1162 20.7466C47.6209 22.6071 49.4915 23.5475 51.7079 23.5475C55.0425 23.5475 57.7469 21.4418 57.7469 18.1706C57.7469 11.1173 49.9999 13.3049 49.9999 10.2382Z",
    fill: "#010202"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_158_53106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 29
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0849 0.0977783H0.976562V28.0658H99.0849V0.0977783Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_158_53106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.9262 20.5422C96.0149 20.5422 95.4659 19.704 95.4659 18.4365V12.7938H98.4549V9.93158H95.4659V6.14935L92.1719 7.64179V19.152C92.1719 22.096 94.1849 23.5885 96.9705 23.5885C97.3975 23.5885 97.8449 23.568 98.2719 23.4862L99.0649 20.5218C98.7192 20.5218 98.2922 20.5422 97.9262 20.5422Z",
    fill: "#010202"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_158_53106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0849 0.0977783H0.976562V28.0658H99.0849V0.0977783Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_158_53106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3084 9.50222C36.7021 9.50222 35.5838 9.97244 34.4858 11.0355V4.84088H31.2324V16.3307C31.2324 20.624 34.3231 23.568 37.8001 23.568C41.6634 23.568 45.0388 20.5627 45.0388 16.5351C45.0591 12.5484 41.9481 9.50222 38.3084 9.50222ZM38.2881 20.2969C37.5561 20.2969 36.8444 20.072 36.2344 19.6631C35.6244 19.2542 35.1568 18.6818 34.8721 18.0071C34.5874 17.3324 34.5264 16.576 34.6688 15.8604C34.8111 15.1449 35.1568 14.4907 35.6854 13.9591C36.1938 13.448 36.8648 13.08 37.5764 12.9369C38.2881 12.7938 39.0404 12.8755 39.7114 13.1413C40.3824 13.4275 40.9518 13.8978 41.3584 14.5111C41.7651 15.1244 41.9888 15.84 41.9888 16.576C41.9888 17.5573 41.6024 18.4978 40.9111 19.1929C40.1994 19.888 39.2641 20.2969 38.2881 20.2969Z",
    fill: "#010202"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_158_53106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 29
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0849 0.0977783H0.976562V28.0658H99.0849V0.0977783Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_158_53106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5866 16.3716C73.5866 12.3236 70.2113 9.33868 66.3479 9.33868C62.8709 9.33868 59.7803 12.2827 59.7803 16.576V28.0658H63.0336V21.8507C64.1113 22.9138 65.2296 23.384 66.8359 23.384C70.4756 23.4045 73.5866 20.3582 73.5866 16.3716ZM70.5163 16.3307C70.5163 17.0667 70.2926 17.7822 69.8859 18.3956C69.4793 19.0089 68.9099 19.4791 68.2389 19.7654C67.5679 20.0516 66.8156 20.1129 66.1039 19.9698C65.3923 19.8267 64.7416 19.4791 64.2129 18.9476C63.7046 18.4365 63.3386 17.7618 63.1963 17.0462C63.0539 16.3307 63.1353 15.5742 63.3996 14.8996C63.6843 14.2249 64.1519 13.6525 64.7619 13.2436C65.3719 12.8347 66.0836 12.6098 66.8156 12.6098C67.7916 12.6098 68.7269 12.9982 69.4183 13.6934C70.1299 14.4089 70.5163 15.3494 70.5163 16.3307Z",
    fill: "#010202"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_158_53106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 29
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0849 0.0977783H0.976562V28.0658H99.0849V0.0977783Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_158_53106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0785 9.17511V5.88355C84.5055 5.67911 84.8715 5.352 85.1358 4.96355C85.4002 4.55466 85.5222 4.08444 85.5222 3.61422V3.53244C85.5222 2.85777 85.2578 2.224 84.7902 1.75378C84.3225 1.28355 83.6718 1.01777 83.0212 1.01777H82.9398C82.2688 1.01777 81.6385 1.28355 81.1708 1.75378C80.7032 2.224 80.4388 2.87822 80.4388 3.53244V3.61422C80.4388 4.08444 80.5812 4.55466 80.8252 4.96355C81.0895 5.37244 81.4555 5.67911 81.8825 5.88355V9.17511C80.6422 9.35911 79.4832 9.89066 78.5072 10.6676L69.5605 3.65511C69.6215 3.43022 69.6622 3.18488 69.6622 2.93955C69.6622 2.36711 69.4995 1.83555 69.1945 1.36533C68.8895 0.895106 68.4422 0.527108 67.9338 0.322664C67.4255 0.097775 66.8562 0.0568855 66.3072 0.159108C65.7582 0.26133 65.2498 0.547553 64.8635 0.935997C64.4772 1.32444 64.1925 1.83555 64.0908 2.38755C63.9892 2.93955 64.0298 3.512 64.2535 4.02311C64.4568 4.53422 64.8228 4.984 65.2905 5.31111C65.7582 5.61777 66.3072 5.80177 66.8562 5.80177C67.3442 5.80177 67.8322 5.65866 68.2592 5.41333L77.0838 12.3031C76.2908 13.5093 75.8842 14.92 75.9045 16.3716C75.9248 17.8231 76.3722 19.2133 77.2058 20.3991L74.5218 23.0978C74.2982 23.0364 74.0745 22.9956 73.8508 22.9956C73.3832 22.9956 72.9358 23.1387 72.5495 23.384C72.1632 23.6498 71.8785 23.9973 71.6955 24.4267C71.5125 24.856 71.4718 25.3262 71.5735 25.776C71.6548 26.2258 71.8785 26.6551 72.2038 26.9822C72.5292 27.3093 72.9358 27.5342 73.4035 27.616C73.8508 27.6978 74.3185 27.6569 74.7455 27.4933C75.1725 27.3093 75.5385 27.0231 75.7825 26.6347C76.0468 26.2462 76.1688 25.7964 76.1688 25.3262C76.1688 25.1013 76.1282 24.8764 76.0672 24.6516L78.7105 21.9938C79.5848 22.6684 80.5812 23.1182 81.6588 23.3431C82.7365 23.568 83.8345 23.5271 84.8918 23.2613C85.9492 22.9751 86.9252 22.464 87.7588 21.7484C88.5925 21.0329 89.2432 20.1333 89.6702 19.1316C90.0972 18.1298 90.3005 17.0258 90.2395 15.9218C90.1785 14.8178 89.8735 13.7547 89.3448 12.7938C88.8162 11.8329 88.0638 11.0151 87.1692 10.3813C86.1932 9.74755 85.1765 9.33866 84.0785 9.17511ZM82.9805 19.9698C82.2485 19.9698 81.5368 19.7449 80.9472 19.3564C80.3372 18.9476 79.8695 18.3751 79.6052 17.7004C79.3205 17.0258 79.2595 16.2898 79.4018 15.5742C79.5442 14.8587 79.8898 14.2044 80.3982 13.6933C80.9065 13.1822 81.5572 12.8347 82.2688 12.6916C82.9805 12.5484 83.7125 12.6302 84.3835 12.896C85.0545 13.1822 85.6238 13.6524 86.0305 14.2453C86.4372 14.8587 86.6405 15.5742 86.6405 16.2898C86.6405 17.2711 86.2542 18.2116 85.5628 18.9067C84.8918 19.5813 83.9565 19.9698 82.9805 19.9698Z",
    fill: "#FF6B48"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHubspot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Hubspot.2632f40bd56f2bd09a3c8793f1158f39.svg";